export default "<div class=\"content\" fxFlex>\r\n    <router-outlet></router-outlet>\r\n</div>";